<template>
  <div id="pc">
    <div v-show="maskShow" class="outSideWrap">
      <div class="appQrcode">
        <span class="close" @click="triggerMask"> &#10005; </span>
        <!-- <a href="#" class="close">

                </a> -->
        <!-- <img src="../assets/img/pc/qrcode.png" alt="logo"> -->
        <qrcode-vue
          :value="popUpQrcodeUrl"
          class="qrcodeImg"
          :size="200"
          level="H"
        ></qrcode-vue>
        <p>手机扫描二维码下载</p>
      </div>
    </div>
    <sideBar></sideBar>
    <header>
      <div class="headerInfo content">
        <div class="infoBlock inlBlock">
          <img src="../assets/img/pc/logo.png" alt="logo" />
          <div class="inlBlock">
            <p class="mr0">彩世界</p>
            <span>{{ siteUrl }}</span>
          </div>
        </div>
        <div class="secInfoBlock inlBlock">
          <p class="mr0">· · 全面即时专业彩票数据精准分析 · ·</p>
        </div>
      </div>
    </header>
    <div class="headerContent">
      <img
        class="headDice"
        src="../assets/img/pc/headerdice.png"
        alt="headerdice"
      />
      <div class="downloadInfoContent inlBlock">
        <div class="dheadInfo">
          <h1 class="inlBlock mr0">AI助力精准预测，打庄高手必备，看片无忧！</h1>
          <span>官方</span>
        </div>
        <p class="dheadmsg">
          该APP提供智能大数据软件，让您享受分分回血的精准计划，多名分析师每天报特码。在聊天室内，与其他彩友即时交流分析。近期加入全球最热门的ChatGPT智能AI问答，带给您前所未有的精准计划体验。
        </p>
        <!-- <p class="mr0">等多彩种的专业数据分析查询聊天软件。是一款涵盖幸运飞艇、北京赛车、重庆时时彩、广东快乐十分、江苏快三和PC蛋蛋等多彩种的彩票应用平台</p> -->
        <ul class="routeList">
          <li>
            <span class="imgWrap">
              <img src="../assets/img/pc/chat.png" alt="alt" />
            </span>
            <p class="mr0">直播聊天室</p>
          </li>
          <li>
            <span class="imgWrap">
              <img src="../assets/img/pc/profressIcon.png" alt="alt" />
            </span>
            <p class="mr0">专家计划</p>
          </li>
          <li>
            <span class="imgWrap">
              <img src="../assets/img/pc/trendIcon.png" alt="alt" />
            </span>
            <p class="mr0">走势分析</p>
          </li>
          <li>
            <span class="imgWrap">
              <img src="../assets/img/pc/historyIcon.png" alt="alt" />
            </span>
            <p class="mr0">历史查询</p>
          </li>
          <li>
            <span class="imgWrap">
              <img src="../assets/img/pc/awardIcon.png" alt="alt" />
            </span>
            <p class="mr0">实时开奖</p>
          </li>
        </ul>
        <!-- <div class="dheadContent">
                    <h3>立即下载：</h3>
                    手机扫描左边二维码快速下载<br/>
                    或 用手机浏览器输入这个网址： <span class="link">http://t.cn/EKWTxfb</span>
                </div> -->
      </div>
      <div class="qrCodeContent inlBlock">
        <div class="qrcodeWrapContent">
          <div class="qrcodeWrap">
            <!-- <img src="../assets/img/pc/qrcode.png" alt="logo"> -->
            <qrcode-vue
              :value="currentUrl"
              class="qrcodeImg"
              :size="185"
              level="H"
            ></qrcode-vue>
            <p>手机扫描二维码下载</p>
          </div>
        </div>
      </div>
    </div>
    <div id="main">
      <div class="fastDownloadInfo">
        <h3>手机快捷下载通道：<span>（一键扫描，多彩种在线下载）</span></h3>
        <p class="center">手机扫描二维码快速下载</p>
        <p class="center">
          或 用手机浏览器输入这个网址： <span>{{ siteUrl }}</span>
        </p>
        <img
          class="scanIcon"
          src="../assets/img/pc/scanIcon.png"
          alt="scanIcon"
        />
      </div>
      <div class="download">
        <div
          v-for="(items, index) in lotteryArray"
          :key="index"
          class="dlBlock"
          @click="moveTo(items.lotteryName)"
        >
          <div class="blockHeader">
            <img
              :src="require(`@/assets/img/` + items.lotteryName + `Logo.png`)"
              alt="logo"
            />
            <div class="appInfo">
              <h3>{{ items.title }}</h3>
              <p>{{ items.appInfo }}</p>
            </div>
            <a
              href="#"
              class="btn redBg"
              @click.stop="showQrcode($event, items.lotteryName)"
            >
              下载 手机 APP 版
            </a>
            <button
              class="btn redBg"
              @click.stop="downloadWindows(items.lotteryName)"
              v-if="items.lotteryName != 'madou'"
            >
              下载 windows 版
            </button>
          </div>
          <div class="blockInfo">
            {{ items.info }}
          </div>
        </div>
      </div>
      <div class="slider redBg">
        <div class="content">
          <Carousel3d
            ref="bannerCarousel"
            :autoplay="true"
            :autoplay-timeout="timeOut"
            :disable3d="true"
            :controls-visible="false"
            :border="0"
            :display="3"
            :height="600"
            :perspective="0"
            :space="400"
            :count="slides"
          >
            <slide v-for="(slide, i) in slideArray" :index="i" :key="i">
              <img
                class="contentImg"
                :src="require(`@/assets/img/pc/banner${i + 1}.png`)"
                alt="banner"
              />
            </slide>
          </Carousel3d>
          <ul class="slidePage">
            <li
              v-for="(slide, i) in slideArray"
              :index="i"
              :key="i"
              :class="returnIndex == i && 'active'"
              @click="getIndex(i)"
            ></li>
          </ul>
        </div>
        <div class="slideControl">
          <a href="#" @click="moveIndex($event, 'prev')" class="arrowBtn prev">
            <img :src="require(`@/assets/img/pc/prevBtn.png`)" alt="prev" />
          </a>
          <a href="#" @click="moveIndex($event, 'next')" class="arrowBtn next">
            <img :src="require(`@/assets/img/pc/nextBtn.png`)" alt="next" />
          </a>
        </div>
      </div>
    </div>
    <div id="bottom">
      <div class="bottomInfo">
        <p>多终端同步，电脑，手机都能看，一款应用多种体验 你值得拥有</p>
        <p class="mr0">快来下载吧！</p>
      </div>
    </div>
  </div>
</template>
<style lang="scss" scoped >
@import "../assets/style/pc.scss";
</style>
<script>
import { Carousel3d, Slide } from "vue-carousel-3d";
import QrcodeVue from "qrcode.vue";
import { setTimeout } from "timers";
import sideBar from "@/components/sideBar";
import { getUrlKey, isKeyEmpty } from "../utils/urltool";
import { mapState } from "vuex";
export default {
  name: "pcpage",
  components: {
    Carousel3d,
    Slide,
    QrcodeVue,
    sideBar,
  },
  mounted() {
    let url = window.location.href;
    this.loadCheck = true;
    this.downChannel = getUrlKey("channel", url);
    this.triggerIndex();
    this.currentUrl = url;
    var _this = this;
    setTimeout(function () {
      _this.siteUrl = window.siteUrl;
    }, 500);
  },
  computed: {
    returnIndex: function () {
      return this.index;
    },
    ...mapState(["lotteryArray"]),
  },
  data() {
    return {
      siteUrl: "",
      loadCheck: false,
      slides: 4,
      downChannel: undefined,
      slideArray: [
        {
          title: ["在线直播聊天室", "千万网友聚集地，高手如云"],
          info: [
            "每天实时讨论最新开奖、往期走势，",
            "人生巅峰路上不孤单。",
            "老哥，我又稳了，带你飞啊！",
          ],
        },
        {
          title: ["专家免费实时推荐", "最专业的大数据分析"],
          info: [
            "专家免费推荐，",
            "每期实时更新，",
            "精准定位，帮你期期都中大奖！",
          ],
        },
        {
          title: ["大数据统计分析", "全方位帮你玩转各种走势图"],
          info: [
            "专业数据统计，",
            "多种玩法走势详解，",
            "一眼就能看懂的走势分析图！",
          ],
        },
        {
          title: ["实时开奖", "快速掌握最新状态"],
          info: [
            "多彩种实时开奖详情，",
            "最新最全历史数据，",
            "一键查询，方便快捷！",
          ],
        },
      ],
      index: 0,
      timeOut: 2000,
      maskShow: false,
      popUpQrcodeUrl: "",
      currentUrl: "",
    };
  },
  methods: {
    triggerIndex() {
      var _this = this;
      setTimeout(function () {
        _this.index = _this.$refs.bannerCarousel.currentIndex;
        _this.triggerIndex();
      }, this.timeOut - 1500);
    },
    getIndex(index) {
      this.index = index;
      this.$refs.bannerCarousel.goSlide(index);
    },
    moveIndex(e, direction) {
      if (e !== undefined) {
        e.preventDefault();
      }
      if (direction == "next") {
        this.$refs.bannerCarousel.goNext();
      } else {
        this.$refs.bannerCarousel.goPrev();
      }
    },
    showQrcode(e, lotteryname) {
      if (e !== undefined) {
        e.preventDefault();
      }
      this.loadQrCodeUrl(lotteryname);
      this.triggerMask();
    },
    downloadWindows(lotteryname) {
      window.location.href = window.windowsLink;
    },
    moveTo(pathname) {
      let url = new URL(window.location.href);
      let searchParams = isKeyEmpty(url.search) ? "" : url.search;
      window.location.href = "./detail/" + pathname + ".html" + searchParams;
    },
    loadQrCodeUrl(pathname) {
      let url = window.location.href;
      let urlArr = url.split("/");
      let urlP = new URL(url);
      let searchParams = isKeyEmpty(urlP.search) ? "" : urlP.search;

      this.popUpQrcodeUrl =
        window.location.protocol +
        "//" +
        urlArr[2] +
        window.location.pathname +
        "detail/" +
        pathname +
        ".html" +
        searchParams;
      // console.log(this.popUpQrcodeUrl);
    },
    triggerMask() {
      if (this.maskShow == false) {
        this.maskShow = true;
      } else {
        this.maskShow = false;
      }
    },
  },
};
</script>
